module.exports = __webpack_public_path__ + "img/error-503.5b76c2d4.svg";